import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ResetPassVerifyEmailPage', {
    title: 'Set a new password',
    passwordLabel: 'Password',
    passwordPlaceholder: 'Enter password',
    setPasswordButton: 'Set a new password',
    successMessage: 'Your password has been successfully changed.',
    codeBeenSent: 'Code has been successfully sent to your email.',
});
